"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconBankSolid = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M62.14 26.82a2.24 2.24 0 0 0 2.25-2.24V21a2.24 2.24 0 0 0-1.52-2.12l-24.32-8.32a11.06 11.06 0 0 0-7.1 0L7.13 18.84A2.24 2.24 0 0 0 5.61 21v3.62a2.24 2.24 0 0 0 2.25 2.24h2.84v23.32h-3a2.11 2.11 0 0 0-2.11 2.1v3.26a2.12 2.12 0 0 0 2.11 2.11h54.58a2.12 2.12 0 0 0 2.11-2.11v-3.26a2.11 2.11 0 0 0-2.11-2.1h-3V26.82zm-24.88 0v23.36h-4.52V26.82h4.52zm-17.8 0H24v23.36h-4.54zm31.08 23.36H46V26.82h4.52z"
  })),
  height: undefined,
  width: undefined
});
IconBankSolid.displayName = 'IconBankSolid';
var _default = IconBankSolid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/bank-solid.js
// module id = 220
// module chunks = 0